import type { ChangeEvent, RefObject } from 'react'
import { useCallback, useRef } from 'react'

export interface UseSquareImageUploadOptions {
  isDisabled: boolean
  onImageChange: (file: File | null) => void
  onImageRemove: () => void
}

export interface UseSquareImageUploadResult {
  fileInputRef: RefObject<HTMLInputElement | null>
  handleClick: () => void
  handleFileChange: (event: ChangeEvent<HTMLInputElement>) => void
  handleRemove: () => void
}

export const useSquareImageUpload = ({
  isDisabled,
  onImageChange,
  onImageRemove,
}: UseSquareImageUploadOptions): UseSquareImageUploadResult => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleClick = useCallback(() => {
    if (isDisabled) return
    fileInputRef.current?.click()
  }, [isDisabled])

  const handleFileChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0]
      if (file) {
        onImageChange(file)
      }
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    },
    [onImageChange]
  )

  const handleRemove = useCallback(() => {
    onImageRemove()
  }, [onImageRemove])

  return {
    fileInputRef,
    handleClick,
    handleFileChange,
    handleRemove,
  }
}
